import React, { useEffect, useState, useRef } from 'react'

import { SVGIcon } from '../wrappers/SVGIcon';

import { Icons } from '../../data/Assets';

interface IVideoPlayerProps {
    src: string;
}

const VideoPlayer = (props: IVideoPlayerProps) => {
    const { src } = props;

    const videoRef = useRef<HTMLVideoElement | null>(null)
    const [isPlaying, setIsPlaying] = useState(false)

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.onended = () => {
                setIsPlaying(false)
            }
        }
    }, [videoRef.current]) // eslint-disable-line

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause()
            } else {
                videoRef.current.play()
            }
            setIsPlaying(!isPlaying)
        }
    }

    return (
        <div className='immersion__video_container'>
            <div className='immersion__video_container__video'>
                <video
                    ref={videoRef}
                    src={src}
                    controls={false}
                />
            </div>
            <button
                className='immersion__btn immersion__btn__outline__primary immersion__video_container__actions_play_btn'
                onClick={handlePlayPause}
            >
                <SVGIcon src={isPlaying ? Icons.PauseCircle : Icons.PlayCircle} />
            </button>
        </div>
    )
}

export default VideoPlayer;